const SoFormStepCard = {
  nameForData: 'SO_FORM_STEP_CARD',
  hideHeader: true,
};

export default SoFormStepCard;
